import React from "react";

import { Switch } from "react-router-dom";

import { ProtectedRoute as Route } from "components/ProtectedRoute";
import { APP_HOME, SOLUTIONS_HOME } from "routers/routePaths";
import { SolutionsHome } from "screens/Solutions/SolutionsHome";
import { OnBoardingRouter } from "screens/onboarding";
import { AdminRouter } from "screens/admin";
import { FramesRouter } from "screens/frames";
import { SolutionsRouter } from "screens/Solutions";
import ErrorBoundaryScreen from "errorBoundary/ErrorBoundaryScreen";
import { GreenEnergyProvider } from "contexts/GreenEnergyContext";

export const ProtectedRouter = () => {
  return (
    <Switch>
      <ErrorBoundaryScreen>
        <GreenEnergyProvider>
          <Route
            exact
            path={[APP_HOME, SOLUTIONS_HOME]}
            component={SolutionsHome}
          />

          {/* OLD ROUTERS */}
          <Route path="/admin" component={AdminRouter} />
          <Route path="/onboarding" component={OnBoardingRouter} />
          <Route path="/frames" component={FramesRouter} />
          <Route path="/solutions" component={SolutionsRouter} />
        </GreenEnergyProvider>
      </ErrorBoundaryScreen>
    </Switch>
  );
};
